import React from "react";

const SearchIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      role="img"
      width="1em"
      height="1em"
      preserveAspectRatio="xMidYMid meet"
      viewBox="0 0 24 24"
    >
      <g fill="none">
        <path
          d="M10.5 13.5L3 21"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          className="il-md-length-15 il-md-duration-2 il-md-delay-6"
        />
        <path
          d="M10.757 13.243a6 6 0 1 1 8.485-8.486a6 6 0 0 1-8.485 8.486z"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          className="il-md-length-40 il-md-duration-5 il-md-delay-0"
        />
      </g>
    </svg>
  );
};

export default SearchIcon;
